import { render, staticRenderFns } from "./TabelaTransferencias.vue?vue&type=template&id=59bee5cd&"
import script from "./TabelaTransferencias.vue?vue&type=script&lang=js&"
export * from "./TabelaTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports